import React, { useLayoutEffect, useRef, useState } from "react";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import "./index.css";

const CommonSectionTab = ({
  tabs = [],
  activeTab,
  setActiveTab,
  height = 44,
  minWidth = 164,
  radius = "var(--width-label)",
  activeBgColor,
  inactiveBgColor,
  hoverOption,
}) => {
  const hasMultipleTabs = tabs.length > GlobalConfiguration?.lengthCheckOne;

  const hoverClass =
    hoverOption === "white" ? "global-hover-white" : "global-hover-black";

  const tabRefs = useRef([]);

  const [indicatorStyle, setIndicatorStyle] = useState({
    width: GlobalConfiguration?.lengthCheckZero,
    height: GlobalConfiguration?.lengthCheckZero,
    transform: "translateX(0px)",
  });

  useLayoutEffect(() => {
    const currentTab = tabRefs.current[activeTab];

    if (!currentTab) return;

    const updateIndicator = () => {
      setIndicatorStyle({
        width: currentTab.offsetWidth,
        height: currentTab.offsetHeight,
        transform: `translateX(${currentTab.offsetLeft}px)`,
        borderRadius: "var(--border-radius-md)",
      });
    };

    updateIndicator();

    const handleResize = () => {
      updateIndicator();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [activeTab, tabs]);

  const handleTabClick = (idx) => {
    if (!hasMultipleTabs) return;
    setActiveTab(idx);
  };

  return (
    <div className="tabs-wrapper relative">
      <div
        className="absolute  z-z-index-base transition-all duration-animation-medium ease-in-out"
        style={{
          ...indicatorStyle,
          background: !hasMultipleTabs
            ? "transparent"
            : activeBgColor
              ? activeBgColor
              : inactiveBgColor,
        }}
      />

      {tabs.map((tab, idx) => {
        const isActive = activeTab === idx;

        return (
          <button
            key={tab.key}
            ref={(el) => (tabRefs.current[idx] = el)}
            className={`tab-btn ${
              isActive ? "" : hoverClass
            } ${isActive ? "active" : ""} relative z-z-index-base`}
            style={{
              minWidth: `${minWidth}px`,
              height: `${height}px`,
              borderRadius: radius,
              cursor: hasMultipleTabs ? "pointer" : "text",
            }}
            onClick={() => handleTabClick(idx)}
          >
            <span
              style={{
                overflow: "hidden",
              }}
            >
              {tab.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default CommonSectionTab;
